import { gql } from "@outschool/ui-apollo";

const CategoryGradeQuery = gql`
  query CategoryPageGradeQuery {
    categoryPages(
      slugs: [
        "preschool"
        "kindergarten"
        "elementary-school"
        "middle-school"
        "high-school"
        "1st-grade"
        "2nd-grade"
        "3rd-grade"
        "4th-grade"
        "5th-grade"
        "6th-grade"
        "7th-grade"
        "9th-grade"
        "10th-grade"
        "11th-grade"
        "12th-grade"
        "10th-grade"
        "11th-grade"
        "12th-grade"
        "toddlers"
        "tweens"
        "teenagers"
      ]
    ) {
      nameTitleCased
      basePath
      slug
    }
  }
`;

export default CategoryGradeQuery;
